<template lang="pug">
  .form-item.group__select
    span.form-item__title(v-if="title")
      | {{title}}
    .form-item__block(v-click-outside="close")
      span.form-item__error(v-if="error")
        | {{error}}

      .form-item__select.select(@click="toggleOpen")
        input.form-item__input(
          :value="value ? value.folder + ': ' + value.course.name  : ''"
          :disabled="true"
          :placeholder="placeholder"
        )
      SlideUpDown.select__slider(
        :duration="slideDuration"
        :active="isOpen"
      )
        .select__field
          SelectItem(
            v-for="(field) in fields"
            :courses="field.courses"
            :folder="field.folder"
            @click="click($event, field.folder.name)"
            :key="field.folder.id"
          )

      Icon.select__icon.form-item__icon(
        :icon="!icon ? 'arrow-down' : icon"
        @click="toggleOpen"
        :class="{'-opened-': isOpen}"
      )
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import SelectItem from './SelectItem';

export default {
  name: 'SelectFeed',
  components: {
    SelectItem,
    SlideUpDown
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    title: {},
    error: {},
    placeholder: {},
    icon: {},
    value: {}
  },
  data() {
    return {
      isOpen: false,
      slideDuration: 200,
      selectData: {}
    };
  },
  methods: {
    toggleOpen() {
      if (this.fields) {
        this.isOpen = !this.isOpen;
      }
    },
    close() {
      this.isOpen = false;
    },
    click(emit, folder) {
      this.$emit('input', { ...emit, folder: folder });
      this.close();
    }
  }
};
</script>
